import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { TokensLanding } from './types';

export function useTokensLandingData(): Page<TokensLanding>['templateFields'] {
  return useCurrentPage<Page<TokensLanding>>().templateFields;
}
